<app-page-header
  [title]="'Proveedores'"
  [breadcrumbs]="breadcrumbs"
  [backgroundImage]="'headers/Proveedores.png'"
></app-page-header>

<div class="
  w-full 
  3xl:px-[295px] 2xl:px-[120px] xl:px-[45px] px-4
  lg:py-15 md:py-10 py-4
">
  <!-- Loading Overlay -->
  @if (isLoading()) {
    <div class="fixed inset-0 bg-black/20 backdrop-blur-xs z-40 flex items-center justify-center transition-opacity duration-300">
      <div class="bg-transparent rounded-full">
        <div class="w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  }
  <div class="grid grid-cols-1 md:grid-cols-12 gap-8">
    <div class="col-span-1 md:col-span-3">
      <app-suppliers-sidebar 
        [category]="supplierType()" 
        (onSearch)="handleSearch($event)" 
        [initialTags]="queryTags()"
        (onTagSelect)="handleSelectedTag($event)"
      ></app-suppliers-sidebar>
    </div>
    <div class="col-span-1 md:col-span-9">
      @if (suppliers().length === 0 && !isLoading()) {
        <div class="flex flex-col items-center gap-4 py-20">
          <span class="material-symbols-outlined text-6xl text-gray-400">
            search_off
          </span>
          <p class="text-gray-500 text-lg">No se encontraron resultados que coincidan con los criterios de búsqueda.</p>
        </div>
      } @else {
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr transition-opacity duration-300"
          [class.opacity-50]="isLoading()"
          [class.opacity-100]="!isLoading()"
        >
          @for (supplier of suppliers(); track supplier.id) {
          <app-member-card
            [odd]="$index % 2 === 0"
            [name]="supplier.title"
            [image]="supplier.imageUrl"
            [isAnimate]="false"
            [link]="'/suppliers/' + supplier.id + '/detail'"
            [recommended]="supplier.recommended"
            [tags]="supplier?.tags"
            [icon]="'images/proveedores.svg'"
            class="h-full"
          ></app-member-card>
          }
        </div>
      }
      
      <!-- Pagination -->
      @if (totalPages() > 1) {
      <div class="flex justify-center gap-4 mt-10 mb-5">
        @if(currentPage() > 1) {
          <button
            (click)="goToPage(currentPage() - 1)"
            [disabled]="isLoading()"
            class="w-12 h-12 border border-border-2 rounded-full font-semibold text-heading-primary hover:bg-secondary hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="material-symbols-outlined">
              keyboard_arrow_left
            </span>
          </button>
        }
        
        @for (pageNum of [].constructor(totalPages()); track $index) {
          <button 
            (click)="goToPage($index + 1)"
            [disabled]="isLoading()"
            [class]="'w-12 h-12 border border-border-2 rounded-full font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ' + 
                    (currentPage() === $index + 1 ? 'bg-secondary text-white' : 'text-heading-primary hover:bg-secondary hover:text-white')"
          >
            {{ $index + 1 }}
          </button>
        }
        
        @if(currentPage() < totalPages()) {
          <button
            (click)="goToPage(currentPage() + 1)"
            [disabled]="isLoading()"
            class="w-12 h-12 border border-border-2 rounded-full font-semibold text-heading-primary hover:bg-secondary hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span class="material-symbols-outlined">
              keyboard_arrow_right
            </span>
          </button>
        }
      </div>
      }
    </div>
  </div>
</div>